import React from 'react'
import Icon from './Icon'
import HelpHomeLink from './HelpHomeLink'
import Container from './Container'

const FormHeader = props => {
  return (
    <div className="pt-8 pb-24 sm:pb-32 md:pb-32 bg-gradient-r-primary relative">
      <div className="absolute left-0 right-0 bottom-0 top-0 w-full overflow-hidden">
        <Icon icon="flower" className="ml-auto mr-0 h-auto" />
      </div>
      <Container>
        <HelpHomeLink variant="light" />
      </Container>
      <div className="relative z-10 max-w-4xl mx-6 lg:mx-auto">
        {props.children}
      </div>
    </div>
  )
}

export default FormHeader
